import * as types from './types';

export const showTable = (output: any) => (dispatch: any) => {
    dispatch({ type: types.TABLE_RESULT_ADD, payload: output });
}

export const clearTable = () => (dispatch: any) => dispatch({ type: types.TABLE_CLEAR });